module.exports = __webpack_public_path__ + "img/sleeve cuff lenght.de0185e1.png";